// extracted by mini-css-extract-plugin
export default {"headers":"header_headers__3wmzj","headersContents":"header_headersContents__2SkWE","headersContentsFlex":"header_headersContentsFlex__ahSQx"};